function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M24 2C11.8412 2 2 11.8396 2 24C2 36.1588 11.8396 46 24 46C36.1588 46 46 36.1604 46 24C46 11.8412 36.1604 2 24 2ZM24 42.5625C13.741 42.5625 5.4375 34.2603 5.4375 24C5.4375 13.741 13.7397 5.4375 24 5.4375C34.259 5.4375 42.5625 13.7397 42.5625 24C42.5625 34.259 34.2603 42.5625 24 42.5625Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M21 14C21 12.3431 22.3431 11 24 11C25.6569 11 27 12.3431 27 14C27 15.6569 25.6569 17 24 17C22.3431 17 21 15.6569 21 14Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M27 34C27 35.6569 25.6569 37 24 37C22.3431 37 21 35.6569 21 34L21 23C21 21.3431 22.3431 20 24 20C25.6569 20 27 21.3431 27 23L27 34Z"
});

function SvgOutlineInfo1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlineInfo1);
export default __webpack_public_path__ + "static/media/outline-info-1.062c378f.svg";
export { ForwardRef as ReactComponent };